import React from 'react';

import { PublicLayout } from '~/widgets/layout/public-layout/layout';

export const LpMarch26Layout = ({ location, pageContext, children }) => (
  <PublicLayout location={location} pageContext={pageContext} dataTheme={'lp-march-26'}>
    {children}
  </PublicLayout>
);
